import { ServerFetch } from '../main-model'

export default class ProductTypeModel extends ServerFetch {
    getProductTypeBy = (data) => this.authFetch({
        url: 'product-type/getProductTypeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getProductTypeLastCode = (data) => this.authFetch({
        url: 'product-type/getProductTypeLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getProductTypeByCode = (data) => this.authFetch({
        url: 'product-type/getProductTypeByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateProductTypeBy = (data) => this.authFetch({
        url: 'product-type/updateProductTypeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertProductType = (data) => this.authFetch({
        url: 'product-type/insertProductType',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deleteProductTypeByCode = (data) => this.authFetch({
        url: 'product-type/deleteProductTypeByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}